const EMAIL_SERVICE_URL = process.env.EMAIL_SERVICE_URL;
const EMAIL_SERVICE_API_KEY = process.env.EMAIL_SERVICE_API_KEY;

export async function enqueueDripCampaign(
  email: string,
  app: "exams" | "open",
): Promise<void> {
  if (!EMAIL_SERVICE_URL || !EMAIL_SERVICE_API_KEY) return;

  const response = await fetch(`${EMAIL_SERVICE_URL}/api/enqueue`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${EMAIL_SERVICE_API_KEY}`,
    },
    body: JSON.stringify({ email, app }),
  });

  if (!response.ok) {
    throw new Error(
      `Drip campaign enqueue failed: ${response.status} ${response.statusText}`,
    );
  }
}

export async function sendMockRegistrationEmail(
  email: string,
  selectedExams: {
    examId: string;
    board: string | null;
    series: string | null;
    subject: string;
  }[],
): Promise<void> {
  if (!EMAIL_SERVICE_URL || !EMAIL_SERVICE_API_KEY) return;

  const response = await fetch(`${EMAIL_SERVICE_URL}/api/enqueue`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${EMAIL_SERVICE_API_KEY}`,
    },
    body: JSON.stringify({
      email,
      app: "exams",
      event: "mock_registration_completed",
      selectedExams,
    }),
  });

  if (!response.ok) {
    throw new Error(
      `Mock registration email failed: ${response.status} ${response.statusText}`,
    );
  }
}
